export default __webpack_public_path__ + "static/media/cortinas nandasmo.44ec61a8.jpg";